import { createContext } from "react";
import useProperties from "../hooks/data/useProperties";

export interface IPropertiesContext extends ReturnType<typeof useProperties> {

};

const PropertiesContext = createContext<IPropertiesContext>({
    data: undefined,
    error: undefined,
    loading: true,
    validating: true,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined },
});

export default PropertiesContext